// DO NOT EDIT MANUALLY! Autogenerated by pnpm codegen
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** An ISO 8601-encoded date */
  ISO8601Date: { input: string; output: string; }
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: { input: string; output: string; }
  Upload: { input: File; output: File; }
};

/** Attributes for Friendly Captcha verification */
export type CaptchaAttributes = {
  sitekey: Scalars['String']['input'];
  solution: Scalars['String']['input'];
};

export type Category = Node & {
  __typename?: 'Category';
  id: Scalars['ID']['output'];
  slug: Scalars['String']['output'];
};

/** Autogenerated return type of CreateJobInterest. */
export type CreateJobInterestPayload = {
  __typename?: 'CreateJobInterestPayload';
  errors: Array<Scalars['String']['output']>;
  jobInterest?: Maybe<JobInterest>;
};

/** Autogenerated return type of CreateJob. */
export type CreateJobPayload = {
  __typename?: 'CreateJobPayload';
  errors: Array<Scalars['String']['output']>;
  job?: Maybe<Job>;
};

export enum ExperienceEnum {
  Junior = 'junior',
  Novice = 'novice',
  Professional = 'professional',
  Senior = 'senior'
}

export type Facet = {
  __typename?: 'Facet';
  count: Scalars['Int']['output'];
  facetId: Scalars['ID']['output'];
  /** @deprecated Use facetId instead */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type Feature = {
  __typename?: 'Feature';
  nettoPrice: Scalars['Int']['output'];
  slug: Scalars['String']['output'];
};

/** Autogenerated return type of FindOrCreateLocation. */
export type FindOrCreateLocationPayload = {
  __typename?: 'FindOrCreateLocationPayload';
  errors: Array<Scalars['String']['output']>;
  location?: Maybe<Location>;
};

export type Job = {
  __typename?: 'Job';
  applicationEmail?: Maybe<Scalars['String']['output']>;
  applicationInstructions: Scalars['String']['output'];
  applicationUrl?: Maybe<Scalars['String']['output']>;
  categories: Array<Category>;
  city?: Maybe<Scalars['String']['output']>;
  companyLogoThumb?: Maybe<Scalars['String']['output']>;
  companyName: Scalars['String']['output'];
  country?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  draft: Scalars['Boolean']['output'];
  experiences: Array<ExperienceEnum>;
  expired: Scalars['Boolean']['output'];
  expiryAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  features?: Maybe<Array<Scalars['ID']['output']>>;
  fullEdit: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isHot: Scalars['Boolean']['output'];
  jobTypes: Array<JobTypeEnum>;
  locationOptions: Array<LocationOptionEnum>;
  locations: Array<Location>;
  myomrUserId: Scalars['String']['output'];
  offerType?: Maybe<Scalars['ID']['output']>;
  publishedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  publishedTimeAgo?: Maybe<Scalars['String']['output']>;
  salaryFrom?: Maybe<Scalars['String']['output']>;
  salaryTo?: Maybe<Scalars['String']['output']>;
  slug: Scalars['ID']['output'];
  startAt: Scalars['ISO8601Date']['output'];
  street?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  zipcode?: Maybe<Scalars['String']['output']>;
};

/** Attributes for creating or updating a job */
export type JobAttributes = {
  applicationEmail?: InputMaybe<Scalars['String']['input']>;
  applicationInstructions: Scalars['String']['input'];
  applicationUrl?: InputMaybe<Scalars['String']['input']>;
  categoryIds: Array<Scalars['ID']['input']>;
  city: Scalars['String']['input'];
  companyLogo?: InputMaybe<Scalars['Upload']['input']>;
  companyName: Scalars['String']['input'];
  country: Scalars['String']['input'];
  description: Scalars['String']['input'];
  experience: Array<ExperienceEnum>;
  features?: InputMaybe<Array<Scalars['ID']['input']>>;
  jobTypes: Array<JobTypeEnum>;
  locationIds: Array<Scalars['ID']['input']>;
  locationOptions: Array<LocationOptionEnum>;
  offerType: Scalars['String']['input'];
  promoCodeId?: InputMaybe<Scalars['ID']['input']>;
  salaryFrom?: InputMaybe<Scalars['String']['input']>;
  salaryTo?: InputMaybe<Scalars['String']['input']>;
  startAt: Scalars['ISO8601Date']['input'];
  street: Scalars['String']['input'];
  title: Scalars['String']['input'];
  zipcode: Scalars['String']['input'];
};

export type JobInterest = {
  __typename?: 'JobInterest';
  createdAt: Scalars['ISO8601DateTime']['output'];
  currentEmployer?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  eventSlug: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  job: Job;
  jobLevel?: Maybe<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
  linkedinUrl?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  partnerCompanySlug: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  userLocale: Scalars['String']['output'];
  userProfileId?: Maybe<Scalars['String']['output']>;
};

/** Attributes for creating a job interest */
export type JobInterestAttributes = {
  currentEmployer?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  eventSlug: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  jobId: Scalars['ID']['input'];
  jobLevel?: InputMaybe<JobLevelEnum>;
  lastName: Scalars['String']['input'];
  linkedinUrl?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  partnerCompanySlug: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  userLocale?: InputMaybe<Scalars['String']['input']>;
};

export enum JobLevelEnum {
  /** Ceo */
  Ceo = 'ceo',
  /** Cfo */
  Cfo = 'cfo',
  /** Cmo */
  Cmo = 'cmo',
  /** Coo */
  Coo = 'coo',
  /** Cto */
  Cto = 'cto',
  /** Director */
  Director = 'director',
  /** Entry */
  Entry = 'entry',
  /** Freelancer */
  Freelancer = 'freelancer',
  /** Head of */
  HeadOf = 'head_of',
  /** Manager */
  Manager = 'manager',
  /** Senior */
  Senior = 'senior',
  /** Student */
  Student = 'student'
}

export enum JobSearchStatusEnum {
  ActivelyLooking = 'actively_looking',
  NotLooking = 'not_looking',
  OpenToConversations = 'open_to_conversations'
}

export enum JobTypeEnum {
  Free = 'free',
  FullTime = 'full_time',
  Intern = 'intern',
  PartTime = 'part_time',
  WorkingStudent = 'working_student'
}

export type Location = Node & {
  __typename?: 'Location';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  placeIdGoogle: Scalars['String']['output'];
};

export enum LocationOptionEnum {
  Hybrid = 'hybrid',
  OnSite = 'on_site',
  Remote = 'remote'
}

export type Mutation = {
  __typename?: 'Mutation';
  createJob: CreateJobPayload;
  createJobInterest: CreateJobInterestPayload;
  findOrCreateLocation: FindOrCreateLocationPayload;
  updateJob: UpdateJobPayload;
  updateUser: UpdateUserPayload;
};


export type MutationCreateJobArgs = {
  attributes: JobAttributes;
};


export type MutationCreateJobInterestArgs = {
  attributes: JobInterestAttributes;
  captcha: CaptchaAttributes;
};


export type MutationFindOrCreateLocationArgs = {
  name: Scalars['String']['input'];
  placeIdGoogle: Scalars['String']['input'];
};


export type MutationUpdateJobArgs = {
  attributes: JobAttributes;
  id: Scalars['ID']['input'];
};


export type MutationUpdateUserArgs = {
  attributes: UserUpdateInput;
  userId: Scalars['ID']['input'];
};

/** An object with an ID. */
export type Node = {
  /** ID of the object. */
  id: Scalars['ID']['output'];
};

export type PriceResult = {
  __typename?: 'PriceResult';
  currency: Scalars['String']['output'];
  currencySymbol: Scalars['String']['output'];
  price: Scalars['String']['output'];
};

export type Pricing = {
  __typename?: 'Pricing';
  basic: Scalars['Int']['output'];
  full: Scalars['Int']['output'];
  internship: Scalars['Int']['output'];
  standard: Scalars['Int']['output'];
};

export type PromoCode = Node & {
  __typename?: 'PromoCode';
  discountPercentage: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  calculate: PriceResult;
  features: Array<Feature>;
  hasExhibitorJobs: Scalars['Boolean']['output'];
  jobDetails: Job;
  jobInterestsByExhibitor: Array<JobInterest>;
  jobsByExhibitor: Array<Job>;
  jobsCategories: Array<Category>;
  me?: Maybe<User>;
  pricing: Pricing;
  promoCode?: Maybe<PromoCode>;
  searchJobs: SearchJobsResult;
  seminars: Array<Seminar>;
  topJobs: Array<Job>;
  topLocations: Array<TopLocation>;
};


export type QueryCalculateArgs = {
  features?: InputMaybe<Array<Scalars['ID']['input']>>;
  offerType: Scalars['ID']['input'];
};


export type QueryHasExhibitorJobsArgs = {
  eventSlug: Scalars['String']['input'];
  partnerCompanySlug: Scalars['String']['input'];
};


export type QueryJobDetailsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryJobInterestsByExhibitorArgs = {
  eventSlug: Scalars['String']['input'];
  partnerCompanySlug: Scalars['String']['input'];
};


export type QueryJobsByExhibitorArgs = {
  eventSlug: Scalars['String']['input'];
  partnerCompanySlug: Scalars['String']['input'];
};


export type QueryPromoCodeArgs = {
  name: Scalars['String']['input'];
};


export type QuerySearchJobsArgs = {
  categories?: InputMaybe<Array<Scalars['ID']['input']>>;
  experiences?: InputMaybe<Array<Scalars['ID']['input']>>;
  locationOptions?: InputMaybe<Array<Scalars['ID']['input']>>;
  locations?: InputMaybe<Array<Scalars['ID']['input']>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTopJobsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTopLocationsArgs = {
  jobsPerLocation?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type SearchJobsResult = {
  __typename?: 'SearchJobsResult';
  categoryFacets: Array<Facet>;
  experienceFacets: Array<Facet>;
  jobCount: Scalars['Int']['output'];
  jobs: Array<Job>;
  locationFacets: Array<Facet>;
  locationOptionFacets: Array<Facet>;
  perPage: Scalars['Int']['output'];
};

export type Seminar = {
  __typename?: 'Seminar';
  date: Scalars['String']['output'];
  description: Scalars['String']['output'];
  fulltitle: Scalars['String']['output'];
  imageurl: Scalars['String']['output'];
  jobtitleMain: Scalars['String']['output'];
  speaker: Scalars['String']['output'];
  speakerImageMain: Scalars['String']['output'];
  speakerMain: Scalars['String']['output'];
  successmessage?: Maybe<Scalars['String']['output']>;
  time: Scalars['String']['output'];
  timeMain: Scalars['String']['output'];
  webinarTag: Scalars['String']['output'];
  webinarid: Scalars['String']['output'];
};

export type TopLocation = {
  __typename?: 'TopLocation';
  id: Scalars['ID']['output'];
  jobs: Array<Job>;
  name: Scalars['String']['output'];
  totalCount: Scalars['Int']['output'];
};

/** Autogenerated return type of UpdateJob. */
export type UpdateJobPayload = {
  __typename?: 'UpdateJobPayload';
  errors: Array<Scalars['String']['output']>;
  job?: Maybe<Job>;
};

/** Autogenerated return type of UpdateUser. */
export type UpdateUserPayload = {
  __typename?: 'UpdateUserPayload';
  errors: Array<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export type User = Node & {
  __typename?: 'User';
  categories: Array<Category>;
  id: Scalars['ID']['output'];
  jobSearchStatus?: Maybe<JobSearchStatusEnum>;
  location?: Maybe<Location>;
  locationOptions: Array<LocationOptionEnum>;
  profileId: Scalars['String']['output'];
  userProperties: UserProperties;
  willingToRelocate: Scalars['Boolean']['output'];
};

export type UserProperties = {
  __typename?: 'UserProperties';
  companyDepartment?: Maybe<Scalars['String']['output']>;
  companyFieldId?: Maybe<Scalars['ID']['output']>;
  companyIndustryId?: Maybe<Scalars['ID']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  companySize?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  jobLevel?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  omrMatchConsent?: Maybe<Scalars['Boolean']['output']>;
  position?: Maybe<Scalars['String']['output']>;
};

export type UserPropertiesInput = {
  companyDepartment?: InputMaybe<Scalars['String']['input']>;
  companyFieldId?: InputMaybe<Scalars['ID']['input']>;
  companyIndustryId?: InputMaybe<Scalars['ID']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  companySize?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  jobLevel: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  omrMatchConsent?: InputMaybe<Scalars['Boolean']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
};

export type UserUpdateInput = {
  categoryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  jobSearchStatus?: InputMaybe<JobSearchStatusEnum>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  locationOptions?: InputMaybe<Array<LocationOptionEnum>>;
  userProperties?: InputMaybe<UserPropertiesInput>;
  willingToRelocate?: InputMaybe<Scalars['Boolean']['input']>;
};
